module.exports = __webpack_public_path__ + "static/img/002@2x.a681742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/002@2x.png
// module id = Exmq
// module chunks = 1